import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class PayCodesService extends AbstractService {
	static payCodesApi = NexusService.payCodesApi;

	static getPaycodes() {
		return this.payCodesApi.getPayCodes().then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	static addPaycode(data) {
		const createReq = {
			payCodeCreatePayload: {},
		};

		if (Object.hasOwn(data, "Name")) {
			createReq.payCodeCreatePayload.Name = data.Name;
		}

		if (Object.hasOwn(data, "OrganizationId")) {
			createReq.payCodeCreatePayload.OrganizationId = data.OrganizationId;
		}
		if (Object.hasOwn(data, "Description")) {
			createReq.payCodeCreatePayload.Description = data.Description;
		}
		if (Object.hasOwn(data, "IsActive")) {
			createReq.payCodeCreatePayload.IsActive = data.IsActive;
		}
		if (Object.hasOwn(data, "PayCodeUseStartDate")) {
			createReq.payCodeCreatePayload.PayCodeUseStartDate = data.PayCodeUseStartDate;
		}
		if (Object.hasOwn(data, "PayCodeUseEndDate")) {
			createReq.payCodeCreatePayload.PayCodeUseEndDate = data.PayCodeUseEndDate;
		}
		if (Object.hasOwn(data, "DisplayPayCode")) {
			createReq.payCodeCreatePayload.DisplayPayCode = data.DisplayPayCode;
		}

		return this.payCodesApi.createPayCode(createReq).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});

	}

	static deletePaycode(id) {
		const deleteReq = {
			id,
		};
		return this.payCodesApi.deletePayCode(deleteReq).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		})
		.catch(error => {
			const apiResponse = {
				error,
			};
			return apiResponse
		});
	}

	static updatePaycode(data) {
		const request = {
			id: data.Id,
			payCodeUpdatePayload: {},
		};

		if (Object.hasOwn(data, "Name")) {
			request.payCodeUpdatePayload.Name = data.Name;
		}

		if (Object.hasOwn(data, "OrganizationId")) {
			request.payCodeUpdatePayload.OrganizationId = data.OrganizationId;
		}
		if (Object.hasOwn(data, "Description")) {
			request.payCodeUpdatePayload.Description = data.Description;
		}
		if (Object.hasOwn(data, "IsActive")) {
			request.payCodeUpdatePayload.IsActive = data.IsActive;
		}
		if (Object.hasOwn(data, "PayCodeUseStartDate")) {
			request.payCodeUpdatePayload.PayCodeUseStartDate = data.PayCodeUseStartDate;
		}
		if (Object.hasOwn(data, "PayCodeUseEndDate")) {
			request.payCodeUpdatePayload.PayCodeUseEndDate = data.PayCodeUseEndDate;
		}
		if (Object.hasOwn(data, "DisplayPayCode")) {
			request.payCodeUpdatePayload.DisplayPayCode = data.DisplayPayCode;
		}

		return this.payCodesApi.updatePayCode(request).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	static gePaycodeById(id) {
		return this.payCodesApi.getPayCodeById(id).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}
}
